export class UserRegisterModel { 
    public userName = "";
    public firstName = ""; 
    public lastName = ""; 
    public email = "";  
    public password = ""; 
    public role = ""; 
    public doesAgree = false;
    public acceptBooking = false;
    public rejectBooking = false;
}

export class ErrorModel { 
    public UserName: Array<string> = [];
    public FirstName: Array<string> = [];
    public LastName: Array<string> = [];
    public Email: Array<string> = [];
    public PhoneNumber: Array<string> = [];
    public DateOfBirth: Array<string> = [];
    public Password: Array<string> = [];
    public PasswordConfirmation: Array<string> = [];
}